<template>
  <div 
    :class="{
      'notification-bar col-span-2': props.timeout,
      'sticky top-0 left-0 w-full z-48': !props.timeout
    }"
  >
    <div
      class="progress-bar h-[5px] bg-green transition-all duration-50 ease-linear"
      :style="{ width: progress + '%' }"
    ></div>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    timeout?: number
  }>()

  const globalsStore = useGlobalsStore()
  const requestStore = useRequestStore()

  const { pageID } = storeToRefs(requestStore)

  const progress = ref(0)
  const pauseInterval = ref(false)

  const getProgresses = () => {
    try {
      const storeProgress = localStorage.getItem('visitedPages')

      return storeProgress ? JSON.parse(storeProgress) : []
    } catch (error) {
      console.error(error)
      return []
    }
  }

  const saveProgress = (newProgress: number) => {
    const progresses = getProgresses()

    const existingIndex = progresses.findIndex((item: any) => item.id === pageID.value)

    if (existingIndex !== -1 && progresses[existingIndex].progress < newProgress && newProgress < 100) {
      progresses[existingIndex].progress = Math.ceil(newProgress)
      localStorage.setItem('visitedPages', JSON.stringify(progresses))
    } 
    else if (existingIndex !== -1 && newProgress >= 100) {
      progresses[existingIndex].progress = 100
      localStorage.setItem('visitedPages', JSON.stringify(progresses))
    } 
    else if (existingIndex === -1) {
      progresses.push({
        id: pageID.value,
        progress: 0
      })

      localStorage.setItem('visitedPages', JSON.stringify(progresses))
    }
  }

  const updateProgress = () => {
    const scrollTop = window.scrollY
    const getInTouchHeight = (document.querySelector('.get-in-touch-section') as HTMLElement) ? (document.querySelector('.get-in-touch-section') as HTMLElement).offsetHeight : 0
    const footerHeight = (document.querySelector('footer') as HTMLElement) ? (document.querySelector('footer') as HTMLElement).offsetHeight : 0
    const similarArticleHeight = (document.querySelector('.related-articles') as HTMLElement) ? (document.querySelector('.related-articles') as HTMLElement).offsetHeight : 0

    const ignoreHeight = getInTouchHeight + footerHeight + similarArticleHeight

    const docHeight = document.documentElement.scrollHeight - window.innerHeight - ignoreHeight
    progress.value = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0

		saveProgress(progress.value)
  }

  onMounted(() => {
    if (props.timeout) {
      const bar = document.querySelector('.progress-bar') as HTMLElement
      const notificationBox = document.querySelector('.page-notification') as HTMLElement

      notificationBox?.addEventListener('mouseover', () => {
        pauseInterval.value = true
      })

      notificationBox?.addEventListener('mouseleave', () => {
        pauseInterval.value = false
      })
      
      let durationTime = props.timeout
      const intervalTime = 50

      progress.value = 100

      setTimeout(() => {
        const timer = setInterval(() => {
          if (pauseInterval.value === false) {
            durationTime -= intervalTime
            progress.value = (durationTime - intervalTime) / props.timeout! * 100
          }

          if (durationTime <= 0) {
            clearInterval(timer)
            progress.value = 0
            globalsStore.changeNotificationState(false)
          }
        }, intervalTime)
      }, 800)
    } else {
      window.addEventListener('scroll', updateProgress)
      updateProgress()
    }

  })

  onUnmounted(() => {
    window.removeEventListener('scroll', updateProgress)
  })
</script>
